import { Inbox, Settings } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { NotificationPreferences } from '@/components/notifications/NotificationPreferences';
import {
  LEARNER_NOTIFICATIONS,
  LEARNER_NOTIFICATIONS_SETTINGS,
} from '@/constants/constant-routes';

const tabs = [
  { to: LEARNER_NOTIFICATIONS, label: 'My Notifications', icon: Inbox },
  { to: LEARNER_NOTIFICATIONS_SETTINGS, label: 'Settings', icon: Settings },
];

export default function LearnerNotificationSettingsPage() {
  const { pathname } = useLocation();

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Notifications</h1>
        <p className="text-gray-500 mt-1">
          Stay updated with your learning progress
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200">
        <nav className="flex gap-4" aria-label="Tabs">
          {tabs.map(({ to, label, icon: Icon }) => {
            const active = pathname === to;
            return (
              <Link
                key={to}
                to={to}
                className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                  active
                    ? 'border-primary-600 text-primary-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </Link>
            );
          })}
        </nav>
      </div>

      <NotificationPreferences />
    </div>
  );
}
